import React, { useState } from 'react';
import { FiPlus, FiEdit, FiTrash2, FiSearch, FiFilter, FiMail, FiPhone, FiMapPin, FiUser } from 'react-icons/fi';

const Users: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterRole, setFilterRole] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');

  // Mock data for users
  const users = [
    {
      id: 1,
      name: 'Rajesh Kumar',
      email: 'rajesh.kumar@email.com',
      phone: '+91 9876543210',
      location: 'Punjab, India',
      role: 'farmer',
      status: 'active',
      joinDate: '2024-12-15',
      lastActive: '2025-01-30',
      avatar: '/api/placeholder/40/40'
    },
    {
      id: 2,
      name: 'Priya Sharma',
      email: 'priya.sharma@email.com',
      phone: '+91 9876543211',
      location: 'Haryana, India',
      role: 'farmer',
      status: 'active',
      joinDate: '2024-11-20',
      lastActive: '2025-01-29',
      avatar: '/api/placeholder/40/40'
    },
    {
      id: 3,
      name: 'Admin User',
      email: 'admin@mandivista.com',
      phone: '+91 9876543212',
      location: 'Delhi, India',
      role: 'admin',
      status: 'active',
      joinDate: '2024-01-01',
      lastActive: '2025-01-30',
      avatar: '/api/placeholder/40/40'
    },
    {
      id: 4,
      name: 'Suresh Patel',
      email: 'suresh.patel@email.com',
      phone: '+91 9876543213',
      location: 'Gujarat, India',
      role: 'farmer',
      status: 'inactive',
      joinDate: '2024-10-05',
      lastActive: '2025-01-15',
      avatar: '/api/placeholder/40/40'
    },
    {
      id: 5,
      name: 'Moderator One',
      email: 'moderator@mandivista.com',
      phone: '+91 9876543214',
      location: 'Mumbai, India',
      role: 'moderator',
      status: 'active',
      joinDate: '2024-06-10',
      lastActive: '2025-01-30',
      avatar: '/api/placeholder/40/40'
    },
    {
      id: 6,
      name: 'Anita Singh',
      email: 'anita.singh@email.com',
      phone: '+91 9876543215',
      location: 'UP, India',
      role: 'farmer',
      status: 'active',
      joinDate: '2024-09-12',
      lastActive: '2025-01-28',
      avatar: '/api/placeholder/40/40'
    }
  ];

  const roles = ['farmer', 'admin', 'moderator'];

  const filteredUsers = users.filter(user => {
    const matchesSearch = user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         user.location.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesRole = filterRole === 'all' || user.role === filterRole;
    const matchesStatus = filterStatus === 'all' || user.status === filterStatus;
    return matchesSearch && matchesRole && matchesStatus;
  });

  const getRoleColor = (role: string) => {
    switch (role) {
      case 'admin':
        return 'bg-red-100 text-red-800';
      case 'moderator':
        return 'bg-blue-100 text-blue-800';
      case 'farmer':
        return 'bg-green-100 text-green-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getRoleIcon = (role: string) => {
    switch (role) {
      case 'admin':
        return FiUser;
      case 'moderator':
        return FiUser;
      case 'farmer':
        return FiUser;
      default:
        return FiUser;
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Users</h1>
         
        </div>
       
      </div>

      
     
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <div className="flex items-center">
            <div className="p-2 bg-blue-100 rounded-lg">
              <FiUser className="h-5 w-5 text-blue-600" />
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-600">Total Users</p>
              <p className="text-xl font-semibold text-gray-900">{users.length}</p>
            </div>
          </div>
        </div>
       
      </div>

      {/* Users Table */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">User Accounts</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  User
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Contact
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Location
                </th>
              
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Join Date
                </th>
              
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredUsers.map((user) => {
                const RoleIcon = getRoleIcon(user.role);
                return (
                  <tr key={user.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                       
                        <div className="ml-4">
                          <div className="text-sm font-medium text-gray-900">{user.name}</div>
                          
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">
                       
                        <div className="flex items-center">
                          <FiPhone className="h-4 w-4 text-gray-400 mr-2" />
                          {user.phone}
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center text-sm text-gray-900">
                        <FiMapPin className="h-4 w-4 text-gray-400 mr-2" />
                        {user.location}
                      </div>
                    </td>
                   
                    
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {user.joinDate}
                    </td>
                  
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Empty State */}
      {filteredUsers.length === 0 && (
        <div className="text-center py-12">
          <FiUser className="mx-auto h-12 w-12 text-gray-400" />
          <h3 className="mt-2 text-sm font-medium text-gray-900">No users found</h3>
          <p className="mt-1 text-sm text-gray-500">
            {searchTerm || filterRole !== 'all' || filterStatus !== 'all'
              ? 'Try adjusting your search or filter criteria.'
              : 'Get started by adding your first user.'
            }
          </p>
        </div>
      )}
    </div>
  );
};

export default Users;
